import { render, staticRenderFns } from "./publicUploadModal.vue?vue&type=template&id=2f76d308"
import script from "./publicUploadModal.vue?vue&type=script&lang=ts"
export * from "./publicUploadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports